import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
export const sliderOneCardConfig: SwiperConfigInterface = {
  a11y: true,
  direction: 'horizontal',
  keyboard: true,
  autoplay: true,
  mousewheel: false,
  scrollbar: false,
  navigation: true,
  pagination: false,
  effect: 'fade',
  slidesPerView: 1,
};

export const testimonialConfig: SwiperConfigInterface = {
  a11y: true,
  direction: 'horizontal',
  slidesPerView: 3,
  spaceBetween: 40,
  keyboard: true,
  mousewheel: false,
  scrollbar: false,
  navigation: false,
  pagination: true,
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 1,
    },
    320: {
      slidesPerView: 1,
    },
  },
};

export const portfolioSwiper: SwiperConfigInterface = {
  a11y: true,
  direction: 'horizontal',
  slidesPerView: 4,
  spaceBetween: 15,
  keyboard: true,
  mousewheel: false,
  scrollbar: false,
  navigation: true,
  pagination: false,
  breakpoints: {
    1024: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 1,
    },
    320: {
      slidesPerView: 1,
    },
  },
};
